import { render, staticRenderFns } from "./appPanel.vue?vue&type=template&id=3b6c498a&scoped=true&"
import script from "./appPanel.vue?vue&type=script&lang=js&"
export * from "./appPanel.vue?vue&type=script&lang=js&"
import style0 from "./appPanel.vue?vue&type=style&index=0&id=3b6c498a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c498a",
  null
  
)

export default component.exports